export default __webpack_public_path__ + "fee36e31717670269a60eb4ca7d59e6e.png";